import React, { useState, useCallback } from "react";
import { isMobile } from "react-device-detect";

import classNames from "classnames";

import { JAVASCRIPT_VOID } from "constant/config";

import ListLayer from "components/boards/post/vod/layer/playlist/ListLayer";
import AddLayer from "components/boards/post/vod/layer/playlist/AddLayer";

export const LAYER = {
	LIST: "LIST",
	ADD: "ADD",
};

const PlaylistLayer = ({ vod, close }) => {
	// 현재 레이어 페이지
	const [layer, setLayer] = useState(LAYER.LIST);

	// 레이어 내 오류 발생
	const [error, setError] = useState(false);

	// 레이어 팝업 클릭 시 닫히지 않도록 처리
	const handleClickLayer = useCallback((event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	}, []);

	return (
		<div
			className={classNames("PlayListAdd", isMobile ? "ui-pop-m" : "ui-pop", { AddList: layer === LAYER.ADD, error })}
			onClick={handleClickLayer}
		>
			{/*재생목록 리스트 레이어 */}
			{layer === LAYER.LIST && <ListLayer vod={vod} onChangeLayer={setLayer} close={close} />}

			{/* 재생목록 추가 레이어 */}
			{layer === LAYER.ADD && <AddLayer onChangeLayer={setLayer} onChangeError={setError} />}

			{/* 재생목록 등록 레이어 닫기 */}
			{!isMobile && (
				<a href={JAVASCRIPT_VOID} className="pop-close" onClick={close}>
					<span>닫기</span>
				</a>
			)}
		</div>
	);
};

export default PlaylistLayer;
